import React, { useState, useEffect } from "react";
import Datatable from "../../component/datatable/Datatable";
import Axios from "axios";

const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS;

export default function Clients() {

    // State is just the array of clients []
    const [data, setData] = useState([]);

    // 1. Reusable fetch function
    const refreshList = () => {
        Axios.get(`${backEndUrl}/auth/consultantLog`, {
            withCredentials: true,
        }).then((res) => {
            // Ensure we are setting the array
            setData(res.data.clients || []);
        }).catch((err) => console.error("Failed to fetch clients", err));
    };

    // 2. Initial Load
    useEffect(() => {
        refreshList();
    }, []); 

    // 3. Listen for Navbar Events
    useEffect(() => {
        const handleClientEvent = (event) => {
            const { type, client, tempId } = event.detail;

            if (type === 'ADD') {
                // Prepend the new client to the existing array
                setData((prevClients) => [client, ...(prevClients || [])]);
            } 
            else if (type === 'UPDATE_REAL_ID') {
                setData((prevClients) => {
                    if (!prevClients) return [client];
                    // Remove the entry with the temp ID
                    const otherClients = prevClients.filter(c => c._id !== tempId);
                    // Add the real client record at the top
                    return [client, ...otherClients];
                });
            } 
            else if (type === 'REFRESH_ALL') {
                refreshList();
            }
        };

        // Attach Listener
        window.addEventListener('CLIENT_ACTION', handleClientEvent);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('CLIENT_ACTION', handleClientEvent);
        };
    }, []);

    return (
        <div className="px-10 pb-10">
            <Datatable 
                clients={data} 
                mode="full"
            />
        </div>
    );
}